import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import {
  faCircleUser,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";

import {
  Box,
  Button,
  Group,
  Space,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";

const ActivateAccountPage = (props) => {
  const history = useHistory();
  
  const [userName, setUserName ] = useState(null)
  const [password, setPassword ] = useState(null)

  const onSubmit = (data) =>
    applicationComander.cmd_verify(userName, data.code, password);

  const form = useForm({
    initialValues: {
      code: "",
    },
  });

  useEffect(() => {
      if (props.location?.state?.userName) {
        setUserName(props.location.state.userName);
      }
  }, [props.location?.state?.userName]);

  useEffect(() => {
      if (props.location?.state?.password) {
        setPassword(props.location.state.password);
      }
  }, [props.location?.state?.password]);

  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title">Activate Your Account</Text>
          <Text className="auth-description">
            Enter the confirmation code.
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              required
              label="Code"
              placeholder="Enter confirmation code"
              className="u-w-100"
              {...form.getInputProps("code")}
            />
            <Text
              size="sm"
              align="right"
              className="auth-link resend-code-link mt-1"
              style={{ marginTop: '1px' }}
              onClick={() => applicationComander.cmd_resend_code(userName)}
            >
              Resend Code
            </Text>

            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                ACTIVATE
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                BACK TO LOGIN
              </Button>
            </Group>

            <Text
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => history.push(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} /> Back to login
            </Text>
          </form>
        </Box>
      </div>
    </div>
  );
};

export default ActivateAccountPage;
